import { render } from "./DoubleCard.vue?vue&type=template&id=634fddfa&scoped=true"
import script from "./DoubleCard.vue?vue&type=script&lang=js"
export * from "./DoubleCard.vue?vue&type=script&lang=js"

import "./DoubleCard.vue?vue&type=style&index=0&id=634fddfa&lang=scss&scoped=true"

import exportComponent from "/home/nodeapps/vitamins/koningsnvteaching/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634fddfa"]])

export default __exports__